import { useEffect, useRef, useState } from 'react';

/**
 * Returns [ref, isVisible] — isVisible becomes true once the element
 * enters the viewport and stays true (one-shot trigger).
 */
const useInView = (options = {}) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(el); // fire once
            }
        }, { threshold: 0.15, ...options }); // eslint-disable-line react-hooks/exhaustive-deps

        observer.observe(el);
        return () => observer.disconnect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return [ref, isVisible];
};

export default useInView;
